<template>
    <div class="CarouselContainer" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
        <div ref="mySwiper" class="swiper-container" :id="+currentIndex" v-if="currentIndex==='1'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide" v-for="(item,index) of data" :key="index">
                    <img :src="item.url"/>
                </div>
            </div>
            <!-- 分页器 -->
            <div class="swiper-pagination"></div>
            <!--导航器-->
            <div class="swiper-button-prev"><img src="../assets/common/ic_left.png"></div>
            <div class="swiper-button-next"><img src="../assets/common/ic_right.png"></div>
        </div>
        <div ref="mySwiper2" class="swiper-container1" :id="+currentIndex" v-if="currentIndex==='2'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide1" v-for="(item,index) of data2" :key="index">
                    <div class="swiperSlide text-center">
                        <img :src="item.url"/><br/>
                        <h2>{{item.name}}</h2>
                        <p>{{item.text}}</p>
                    </div>
                </div>
            </div>
            <!-- 分页器 -->
            <!--            <div class="swiper-pagination" style="display: none"></div>-->
            <!--导航器-->
            <!--            <div class="swiper-button-prev"></div>-->
            <!--            <div class="swiper-button-next"></div>-->
        </div>
        <div ref="mySwiper3" class="swiper-container3" :id="currentIndex" v-if="currentIndex==='3'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide" v-for="(item,index) of data3" :key="index">
                    <img :src="item.url"/>
                </div>
            </div>
            <!-- 分页器 -->
            <!--            <div class="swiper-pagination" ></div>-->
            <!--导航器-->
            <div class="swiper-button-prev"><img src="../assets/common/ic_left.png"></div>
            <div class="swiper-button-next"><img src="../assets/common/ic_right.png"></div>
        </div>
        <div ref="mySwiper4" class="swiper-container4" :id="currentIndex" v-if="currentIndex==='4'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide" v-for="(item,index) of data4" :key="index">
                    <div class="slideItem">
                        <h1>{{item.name}}</h1>
                        <p>{{item.text}}</p>
                        <img :src="item.url">
                    </div>
                </div>
            </div>
            <!-- 分页器 -->
            <!--<div class="swiper-pagination" ></div>-->
            <!--导航器-->
            <div class="swiper-button-prev"><img src="../assets/common/ic_left.png"></div>
            <div class="swiper-button-next"><img src="../assets/common/ic_right.png"></div>
        </div>
        <div ref="mySwiper5" class="swiper-container1" :id="+currentIndex" v-if="currentIndex==='5'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide1" v-for="(item,index) of data2" :key="index">
                    <div class="swiperSlide text-center">
                        <img :src="item.url"/><br/>
                        <h2>{{item.name}}</h2>
                        <p>{{item.text}}</p>
                    </div>
                </div>
            </div>
            <!-- 分页器 -->
            <!--            <div class="swiper-pagination" style="display: none"></div>-->
            <!--导航器-->
            <!--            <div class="swiper-button-prev"></div>-->
            <!--            <div class="swiper-button-next"></div>-->
        </div>
        <div ref="mySwiper6" class="swiper-container6" :id="+currentIndex" v-if="currentIndex==='6'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide6" v-for="(item,index) of data6" :key="index">
                    <div class="swiperSlide">
                        <h2>{{item.name}}</h2>
                        <p>{{item.text}}</p>
                        <p>{{item.text1}}</p>
                        <img :src="item.url"/><br/>
                    </div>
                </div>
            </div>
            <!-- 分页器 -->
            <div class="swiper-pagination swiper-pagination6">
            </div>
        </div>
        <div ref="mySwiper7" class="swiper-container swiper-container7" :id="+currentIndex" v-if="currentIndex==='7'">
            <div class="swiper-wrapper">
                <div class="swiper-slide my-swiper-slide" v-for="(item,index) of data" :key="index">
                    <img :src="item.url"/>
                </div>
            </div>
            <!-- 分页器 -->
            <div class="swiper-pagination"></div>
            <!--导航器-->
            <div class="swiper-button-prev"><img src="../assets/common/ic_left.png"></div>
            <div class="swiper-button-next"><img src="../assets/common/ic_right.png"></div>
        </div>
    </div>
</template>
<script>
    import Swiper from 'swiper'
    import "swiper/css/swiper.css";

    export default {
        name: 'CarouselContainer',
        props: ['slideList', 'currentIndex', 'type'],
        data() {
            return {
                currentSwiper: null,
                data: [
                    {url: require('../assets/swiperImg/hardware1.png')},
                    {url: require('../assets/swiperImg/hardware2.png')},
                    {url: require('../assets/swiperImg/hardware3.png')},
                    {url: require('../assets/swiperImg/hardware4.png')},
                    {url: require('../assets/swiperImg/hardware8.png')},
                    {url: require('../assets/swiperImg/hardware6.png')},
                    {url: require('../assets/swiperImg/hardware7.png')},
                    {url: require('../assets/swiperImg/hardware5.png')},
                ],
                data2: [
                    {
                        url: require('../assets/swiperImg/watch1.png'),
                        name: 'AF3 全网通智能手表',
                        text: 'ECG 心电检测，4PD动态心率血氧传感器和体温监测'
                    },
                    {
                        url: require('../assets/swiperImg/watch2.png'),
                        name: 'AF3 Ultra蓝牙智能手表',
                        text: 'ECG 心电检测、动态心率、血氧、血压趋势和体温监测'
                    },
                    {
                        url: require('../assets/swiperImg/watch3.png'),
                        name: '4G气泵血压智能手表',
                        text: '4G款血压，随时随地，精准测量，无需配对手机，数据直传后台，方便健康管理服务'
                    },
                    {
                        url: require('../assets/swiperImg/watch4.png'),
                        name: 'L18 4G智能手表',
                        text: 'ECG 心电检测，4PD动态心率血氧传感器和体温监测'
                    },
                    {
                        url: require('../assets/swiperImg/watch5.png'),
                        name: 'GT3 4G智能手表',
                        text: '4G高性价比，性能稳定，出货量大，民政集采爆款'
                    },
                ],
                data3: [
                    {url: require('../assets/swiperImg/homeSw1.png')},
                    {url: require('../assets/swiperImg/homeSw2.png')},
                    {url: require('../assets/swiperImg/homeSw3.png')},
                    {url: require('../assets/swiperImg/homeSw4.png')},
                ],
                data4: [
                    {
                        url: require('../assets/swiperImg/algorithm1.png'),
                        name: '心率分析',
                        text: '人体正常心率在60~100次/分, 心泰健康算法，精准分析每个脉搏波，精细化分析判断心脏跳动是否规律，与临床医疗器械holter“金标”比对，监测心脏病风险，敏感性和特异性高达95%以上。'
                    },
                    {
                        url: require('../assets/swiperImg/algorithm2.png'),
                        name: '脉搏波分析',
                        text: '自动、无感、周期性监测，自我心脏健康早筛，及时发现心脏健康风险，预警心脏恶性事件发生。'
                    },
                    {
                        url: require('../assets/swiperImg/algorithm3.png'),
                        name: '一键心电',
                        text: '一键心电，准确分析多种心律失常，一键生成AI报告，专家在线解读，早发现早干预。'
                    },
                ],
                data5: [
                    {url: require('../assets/swiperImg/watch1.png'), name: '房颤早筛', text: '2018年10月'},
                    {url: require('../assets/swiperImg/watch1.png'), name: '房颤预警', text: '2019年01月'},
                    {url: require('../assets/swiperImg/watch1.png'), name: '早搏筛查', text: '2019年09月'},
                    {url: require('../assets/swiperImg/watch1.png'), name: '睡眠呼吸暂停风险', text: '2019年12月'},
                ],
                data6: [
                    {
                        url: require('../assets/swiperImg/al1.png'),
                        pagename: '连续无创血压',
                        name: '连续无创血压趋势算法',
                        text: '1、通过提取智能穿戴的脉搏波特征参数，根据波形幅度和形态逐步回归分析建立的血压特征方程 评估每搏血压。',
                        text1: ' 2、通过心电和脉搏计算脉搏波传导速度…'
                    },
                    {
                        url: require('../assets/swiperImg/al2.png'),
                        pagename: '无创血糖',
                        name: '无创血糖趋势算法',
                        text: '基于人体电阻抗，通过特定温度、红外光学、电子脉冲，获取相关糖代谢热量信号，结合血氧计算血糖浓度、供气量数据函数的相对变化，建立连续无创血糖趋势。'
                    },
                    {
                        url: require('../assets/swiperImg/al3.png'),
                        pagename: '动脉粥样硬化',
                        name: '动脉粥样硬化算法',
                        text: '长程心律失常风险监测，定期测量计算脉搏波传导速度，结合血生化检验指标，评估血管弹性、粥样硬化健康风险。及早提醒及早干预，防止冠心病、猝死等恶性事件发生。'
                    },
                    {
                        url: require('../assets/swiperImg/al4.png'),
                        pagename: '血液粘稠',
                        name: '血液粘稠算法',
                        text: '计算脉搏波传导速度，结合长程心率、HRV和心律失常分析，计算血流速度，评估血液粘滞度。高粘滞血症引起血栓危害风险，粘稠度低则多见于贫血。'
                    },
                    {
                        url: require('../assets/swiperImg/al5.png'),
                        pagename: '跌倒监测',
                        name: '跌倒监测算法',
                        text: '养老场景多见，不同疾病导致的跌倒形态各异，通过智能穿戴三轴+角速度数值，结合健康风险指标，建立相应的跌倒模型，让用户得到及时有效的救治干预。'
                    },
                    {
                        url: require('../assets/swiperImg/al6.png'),
                        pagename: '更多算法',
                        name: '智能穿戴更多算法研究，更多应用场景有待拓展',
                        text: '智能穿戴更多算法研究，更多应用场景有待拓展'
                    },
                ],
                data7: [
                    {url: require('../assets/endowment/end_w1.png')},
                    {url: require('../assets/endowment/end_w2.png')},
                    {url: require('../assets/endowment/end_w3.png')},
                    {url: require('../assets/endowment/end_w4.png')},
                    {url: require('../assets/endowment/end_w5.png')},
                    {url: require('../assets/endowment/end_w6.png')},
                    {url: require('../assets/endowment/end_w1.png')},
                    {url: require('../assets/endowment/end_w2.png')},
                ],
            }
        },
        created(){
            switch(this.currentIndex){
                case '1':break;
                case '2':break;
                case '3':break;
                case '4':break;
                case '5':break;
                case '6':break;
                case '7':break;
                case '8':break;
                case '9':break;
            }
        },
        mounted() {
            this.$nextTick(() => {
               setTimeout(()=>{
                   this.initSwiper()
               })
            })
        },
        methods: {
            //鼠标移入暂停自动播放
            stopAutoPlay() {
                this.currentSwiper.autoplay.stop()
            },
            //鼠标移出开始自动播放
            startAutoPlay() {
                this.currentSwiper.autoplay.start()
            },
            //初始化swiper
            initSwiper() {
                // eslint-disable-next-line
                let that = this;//获取vue组件实例
                //一个页面有多个swiper实例时，为了不互相影响,绑定容器用不同值或变量绑定
                this.currentSwiper = new Swiper('#' + this.currentIndex, {
                    loop: true, // 循环模式选项
                    autoHeight: 'true',//开启自适应高度,容器高度由slide高度决定
                    //分页器
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,//分页器按钮可点击
                    },
                    on: {
                        //此处this为swiper实例
                        //切换结束获取slide真实下标
                        slideChangeTransitionEnd: function () {
                            // console.log(that.$props.currentIndex+"号swiper实例真实下标",this.realIndex)
                        },
                        //绑定点击事件,解决loop:true时事件丢失
                        // eslint-disable-next-line
                        click: function (event) {
                            // console.log("你点击了"+that.$props.currentIndex+"号swiper组件")
                        }
                    },
                    //导航器
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    autoplay: {
                        //自动播放,不同版本配置方式不同
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    slidesPerView: that.$props.currentIndex === '1' ? 3 : that.$props.currentIndex === '6' ? 4 : 1, //视口展示slide数1,5
                    slidesPerGroup: 1, //slide数1页一组
                    spaceBetween: 0,
                    offsetPxBefore: 0,
                    effect: that.$props.currentIndex === '1' || that.$props.currentIndex === '6' ? 'coverflow' : '',
                    coverflowEffect: that.$props.currentIndex === '1' || that.$props.currentIndex === '6' ? {
                        rotate: 0,
                        stretch: 0,
                        depth: 1,
                        modifier: 1,
                        slideShadows: true
                    } : {},
                    scrollbar: {
                        container: '.swiper-scrollbar',
                        draggable: false,
                    }
                })

            },
            //销毁swiper
            destroySwiper() {
                try {
                    this.currentSwiper.destroy(true, false)
                } catch (e) {
                    // console.log("删除轮播")
                }
            },
            //更新swiper
            updateSwiper() {
                // this.destroySwiper()
                this.$nextTick(() => {
                    this.initSwiper()
                })
            },
        },
        destroyed() {
            this.destroySwiper()
        }
    }
</script>
<style scoped>
    .my-swiper-slide{
        display: flex;
        align-content: center;
        justify-content: center;
    }
    .swiper-container6 {
        width: 100%;
        height: 670px;
    }
    .swiper-container7{
        width: 50%;
        height: 473px!important;
    }
    .my-swiper-slide6 {
        margin: 0 36px;
    }

    .my-swiper-slide6 .swiperSlide {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 10px 40px 0px rgba(0, 25, 80, 0.1);
        border-radius: 10px;
        padding: 24px 10px;
        height: 540px;
    }

    .my-swiper-slide6 img {
        height: 320px !important;
    }

    /*自定义分页器按钮常规样式*/
    /deep/ .swiper-container6 .swiper-pagination {
        width: 100%;
        overflow: hidden;
        height: 70px;
        background: #e2e9fc !important;
        border-radius: 35px;
        padding: 0 !important;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet {
        width: 16.05%;
        height: 70px;
        background: rgba(218, 228, 252, .71);
        border-radius: 35px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        display: inline-flex;
        align-content: center;
        justify-content: center;
        border: none !important;
        position: relative;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet-active {
        background: #176CF1 !important;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet-active:before {
        color: #ffffff !important;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet:nth-child(1):before {
        content: '连续无创血压';
        color: #000000;
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet:nth-child(2):before {
        content: '无创血糖';
        color: #000000;
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet:nth-child(3):before {
        content: '动脉粥样硬化';
        color: #000000;
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet:nth-child(4):before {
        content: '血液粘稠';
        color: #000000;
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet:nth-child(5):before {
        content: '跌倒监测';
        color: #000000;
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
    }

    /deep/ .swiper-pagination6 .swiper-pagination-bullet:nth-child(6):before {
        content: '更多算法';
        color: #000000;
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
    }


    .slideItem {
        height: 300px;
        background: #FFFFFF;
        box-shadow: 0px 10px 40px 0px rgba(0, 25, 80, 0.1);
        border-radius: 10px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        position: relative;
        padding: 50px;
        margin: 0 60px;
    }

    .slideItem p {
        max-width: 50%;
    }

    .slideItem h1 {
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 52px;
        position: relative;
    }

    .slideItem h1:after {
        width: 30px;
        height: 4px;
        background: #275CE6;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .slideItem img {
        height: 440px;
        position: absolute;
        right: 0;
        top: -22%;
    }

    .CarouselContainer {
    }

    /*slide样式*/
    .my-swiper-slide {
        /*height: 640px;*/
    }

    /*swiper容器样式*/
    .swiper-container {
        width: 100%;
        height: 640px;
    }

    .swiper-container1 {
        width: 100%;
    }

    .swiper-container3 {
        width: 700px;
        height: 650px;
    }

    .swiper-container4 {
        width: 100%;
        margin: 80px 0;
    }

    .my-swiper-slide1 {
        height: 400px;
        display: flex;
        align-items: center;
    }

    .swiperSlide {
        background: #ffffff;
        /*margin: 0 10px;*/
        height: 320px;
    }

    .swiperSlide img {
        height: 180px;
    }

    .swiperSlide h2 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
        margin: 20px 0 14px 0;
        padding: 0 20px;
    }

    .swiperSlide p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #91909A;
        line-height: 20px;
        padding: 0 20px;
    }

    .swiper-pagination {
        margin-top: 20px;
        padding: 20px 0 0 0;
        background: #F3F5FA;
        border-radius: 49px;
    }

    /*!*自定义分页器按钮被点击选中时的样式*!*/
    /deep/ .swiper-pagination-bullet-active {
        background: #f0ad4e;
        width: 66px;
        height: 66px;
        border: 4px solid #76ABFF !important;
    }

    /deep/ .swiper-pagination-bullet {
        opacity: 1;
        border: 4px solid #ffffff;
        width: 66px;
        height: 66px;
    }

    /*自定义分页器按钮常规样式*/
    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(1) {
        background: url("../assets/swiperImg/hd3.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(2) {
        background: url("../assets/swiperImg/hd5.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(3) {
        background: url("../assets/swiperImg/hd8.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(4) {
        background: url("../assets/swiperImg/hd6.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(5) {
        background: url("../assets/swiperImg/hd2.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(6) {
        background: url("../assets/swiperImg/hd1.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(7) {
        background: url("../assets/swiperImg/hd4.png");
    }

    /deep/ .swiper-container .swiper-pagination-bullet:nth-child(8) {
        background: url("../assets/swiperImg/hd7.png");
    }

</style>
